export class Licensing {
    Repossession: string;
    Other: string;
}

export class RecoveryVendorCredentials {
    // Licensing: Licensing;
    // VendorBond: string;
    // Insurance: string;
    // Other: string;
    // Identification: string;
    // UseOfLicenseplateRecognitionData: string;

    RepossessionLicense: string;
    OtherRequiredLicenses: string;
    Bonds: string;
    Certifications: string;
    // Insurance: string;
    // Other: string;
    Identification: string;
    // UseOfLicenseplateRecognitionData: string;
}

export class PreRepossession {
    // ActionsRequiredBeforeEngagingAgent: String;
    // SelfHelp: String;
    // UniqueRestrictions: String;
    // VoluntarySurrenderInformation: String;
    // PoliceNotification: String;
    PreRepossessionNotice: { type: String };
    SelfHelp: { type: String };
    Restrictions: { type: String };
    PoliceNotification: { type: String }
}


export class PostRepossession {
    PoliceNotification: string;
    // NoticeOfSeizureToDebtor: string;
    NoticeOfRepossession: string;

    Means: string;
    RequiredInformation: string;
    Timing: string;
    Form: string;
    RightToCureState: string;
    RightToRedeemreinstate: string;
}

export class AgentLendorResponsibilities {
    PostRepossessionNotice: string;
    Means: string;
    Timing: string;
    Form: string;
    ProofOfRetention: string;
}

export class PersonalPropertyEffects {
    //   Definition: string;
    LicesePlates: string;
    Notices: string;
    //   PostRepossessionNotice: string;
    Means: string;
    Timing: string;
    RequiredInformation: string;
    Form: string;
    ProofOrRetentionOfNotice: string;
    InventoryRequirements: string;
    StorageRequirements: string;
    DisposalRequirements: string;
    Fees: string;

    // Retention: string;
    // Storage: string;
    // TimePeriod: string;
    // Disposal: string;
    // PreDisposalNotice: string;
    // AllowedMeans: string;


    /*  "LicesePlates": "",
        "Notices": "",
        "Means": "",
        "Timing": "",
        "RequiredInformation": "",
        "Form": "",
        "ProofOrRetentionOfNotice": "",
        "InventoryRequirements": "",
        "StorageRequirements": "",
        "DisposalRequirements": "",
        "Fees": "" */

}

export class StorageFees {
    Vehicle: string;
    PersonalProperty: string;
    FeeCollection: string;
    // ApplicationOfExpense: string;
    ApplicationOfExpenses: string;
    // LenderApplicationOfExpenses: string;

}

export class VehicleSaleDisposal {
    // PublicVsPrivate: string;
    // SaleNoticeRequires: number | string;
    // NoticePeriod: string;
    // Means: string;
    // ForPublicSaleStates: string;
    // Form: string;
    // VehicleTitleLaws: string;

    PublicVsPrivate: string;
    NoteOfSale: string;
    NoticePeriod: string;
    Means: string;
    SpecialPublicSalesRequirements: string;
    VehicleTitleProcessing: string;

    // ForPublicSaleStates: string;
    // Form: string;
    // VehicleTitleLaws: string;

    // "PublicVsPrivate": "",
    // "NoteOfSale":"",
    // "NoticePeriod": "",
    // "Means": "",
    // "SpecialPublicSalesRequirements": "",
    // "Form": "",
    // "VehicleTitleProcessing":""
}

export class StateRequirement {
    Disclaimer;
    Info: any;
    Status: number;
    Details: any;
    StateCode: string;
    VendorId: string;
    RecoveryVendorCredentials: RecoveryVendorCredentials;
    PreRepossession: PreRepossession;
    PostRepossession: PostRepossession;
    PersonalPropertyEffects: PersonalPropertyEffects;
    StorageFees: StorageFees;
    VehicleSaleDisposal: VehicleSaleDisposal;
    created_by: string;
    updated_by: string;
}




// WEBPACK FOOTER //
// ./src/app/model/staterequirements.model.ts